import { useState, useEffect, useCallback } from 'react';
import { FetchResult, useQuery, useMutation } from '@apollo/client';
import {
  AreaOfExcellence,
  GetAreasOfExcellenceQuery,
  ConfigureAreasOfExcellenceMutation,
  ConfigureAreasOfExcellenceMutationVariables
} from 'graphql.types';

import getAreasOfExcellence from 'settings/graphql/getAreasOfExcellence';
import configureAreasOfExcellenceInput from 'settings/graphql/configureAreasOfExcellence';

type UpdateAoeResponse = FetchResult<ConfigureAreasOfExcellenceMutation>;

interface AreasOfExcellenceResponse {
  loading: boolean;
  updating: boolean;
  updateAoe: (newAoe: Array<AreaOfExcellence>) => Promise<UpdateAoeResponse>;
  areasOfExcellence: Array<AreaOfExcellence>;
  activeAreasOfExcellence: Array<AreaOfExcellence>;
}

export function useAreasOfExcellence(): AreasOfExcellenceResponse {
  const [activeAreasOfExcellence, setActiveAreasOfExcellence] = useState<
    Array<AreaOfExcellence>
  >([]);
  const { loading, data } =
    useQuery<GetAreasOfExcellenceQuery>(getAreasOfExcellence);

  const [configureAoe, { loading: updating }] = useMutation<
    ConfigureAreasOfExcellenceMutation,
    ConfigureAreasOfExcellenceMutationVariables
  >(configureAreasOfExcellenceInput);

  const areasOfExcellence = data?.company?.allAoe || [];

  useEffect(() => {
    if (data?.company.activeAoe) {
      setActiveAreasOfExcellence(data?.company.activeAoe);
    }
  }, [data]);

  const updateAoe = useCallback(
    (newAoe: AreaOfExcellence[]) => {
      const aoeIds: number[] = newAoe.map(aoe => aoe.id);
      return configureAoe({ variables: { aoe: aoeIds } });
    },
    [configureAoe]
  );

  return {
    loading,
    updating,
    updateAoe,
    areasOfExcellence,
    activeAreasOfExcellence,
  };
}
